import { io } from "socket.io-client";

const CONNECTION_STRING =
  window.location.protocol + "//" + window.location.host;

let socket;

const instantiateConnection = () => {
  socket = io(CONNECTION_STRING);

  return socket;
};

export const closeConnection = () => {
  if (socket) socket.disconnect();
};

export const getSocketInstance = () => {
  if (!socket) return instantiateConnection();

  return socket;
};
